import { SelectFields } from '@repo/toolkit/types'

import { Center } from '../../lib/types/models/center/center'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentCenter<T extends FieldsSelector<Center>>(
  enrollmentId: number,
  fields: T
) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.enrollments.getEnrollmentCenter.url, { id: enrollmentId }),
        { fields }
      )
    )
    .get<SelectFields<Center, T>>()
}
